import React from "react"
import * as styles from "./section-about.module.scss"
import { useBreakpoint } from "gatsby-plugin-breakpoints"

import AnimScroll from "./anim-scroll"

import ImgTitleAboutPC from "../images/title-about_pc.png"
import ImgTitleAboutSP from "../images/title-about_sp.png"
import ImgSystem from "../images/img-system.png"

/**
 * About Park Direct for Business
 */
export default function About() {
  const breakpoints = useBreakpoint()
  return (
    <div className={styles.container}>
       <div className={styles.contents}>
          {breakpoints.sp ? (
            <div className={styles.about}>
              <AnimScroll className={styles.description} animType="fade">
                <img src={ImgTitleAboutSP} alt="Park Direct for Businessは、導入実績No.1のPark Directが提供する法人車両用駐車場管理システムです。"/>
              </AnimScroll>
              <AnimScroll>
                <div className={styles.usage}>
                    <div>
                        <p>駐車場に関する業務の</p>
                        <div>
                            <p>検索</p>
                            <p>契約</p>
                            <p>管理</p>
                            <p>支払</p>
                        </div>
                    </div>
                    <p>すべてをオンライン化・アウトソーシングで<br/>大幅に効率化！</p>
                </div>
              </AnimScroll>
              <AnimScroll className={styles.system_image}>
                <img src={ImgSystem} alt="システム画面" />
              </AnimScroll>
          </div>
          ):(
          <div className={styles.about}>
              <AnimScroll className={styles.description} animType="fade">
                <img src={ImgTitleAboutPC} alt="Park Direct for Businessは、導入実績No.1のPark Directが提供する法人車両用駐車場管理システムです。"/>
              </AnimScroll>
              <AnimScroll>
                <div className={styles.usage}>
                    <div>
                        <p>駐車場に関する業務の</p>
                        <div>
                            <p>検索</p>
                            <p>契約</p>
                            <p>管理</p>
                            <p>支払</p>
                        </div>
                    </div>
                    <p>すべてをオンライン化・アウトソーシングで大幅に効率化！</p>
                </div>
              </AnimScroll>
              <AnimScroll className={styles.system_image}>
                <img src={ImgSystem} alt="システム画面" />
              </AnimScroll>
          </div>
          )}
          <p className={styles.note}>※「月極駐車場のオンライン契約サービス」の「導入社数」（サービス導入をしている不動産管理会社数）と「オンライン契約可能台数」について、2022年12月・2023年12月の㈱エクスクリエによる対象各社（駐車場のシェアリングサービス・サブリースは除く）へのヒアリング調査、並びに、2024年11月・2025年11～12月の株式会社未来トレンド研究機構によるサービス提供事業者に対するヒアリング調査及びデスクリサーチ。「オンライン契約者数」について、2025年11～12月の株式会社未来トレンド研究機構によるサービス提供事業者に対するヒアリング調査及びデスクリサーチ。</p>
        </div>
    </div>
  )
}
